<style>
.el-menu--popup {
    z-index: 100;
    min-width: 150px !important;
    border: none;
    padding: 0 !important;
    border-radius: var(--el-border-radius-small);
    box-shadow: var(--el-box-shadow-light);
}
</style>
<template>
  <div class="head-div">
    <el-radio-group class="nav-el-radio" v-model="isCollapse" style="margin-bottom: 20px">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">折叠</el-radio-button>
    </el-radio-group>
    <el-menu default-active="2" :collapse="isCollapse" @open="handleOpen" @close="handleClose"
      style="border-right: none;">
      <el-sub-menu index="1">
        <template #title>
          <el-icon style="margin-right: 8px;"><span class="iconfont icon-shujuzhongxin1" style="font-size: 1.1rem !important;"></span></el-icon>
          <span>数据中心</span>
        </template>
        <el-menu-item-group>
          <router-link to="" class="router-link"><el-menu-item index="1-1"><span class="iconfont icon-shouye" style="font-size: 1.1rem !important;margin-right: 8px;"></span>控制台</el-menu-item></router-link>
          <router-link to="/admin/withdrawal" class="router-link"><el-menu-item index="1-2"><span class="iconfont icon-rizhi" style="font-size: 1.1rem !important;margin-right: 8px;"></span>提现中心</el-menu-item></router-link>
          <router-link to="" class="router-link"><el-menu-item index="1-3"><span class="iconfont icon-rizhi" style="font-size: 1.1rem !important;margin-right: 8px;"></span>用户日志</el-menu-item></router-link>
        </el-menu-item-group>
      </el-sub-menu>
      <router-link to="" class="router-link">
        <el-menu-item index="2">
          <el-icon><icon-menu /></el-icon>
          <template #title>代理中心</template>
        </el-menu-item>
      </router-link>
      <router-link to="" class="router-link">
        <el-menu-item index="3">
          <el-icon><icon-menu /></el-icon>
          <template #title>插件中心</template>
        </el-menu-item>
      </router-link>
      <!-- <el-menu-item index="4" @click="openDialog('消息', '您确认要退出登录吗', true, 'outLogin')">
        <span class="iconfont icon-tuichu" style="margin-right: 7px;margin-left: 3px;"></span>
        <template #title>退出登录</template>
      </el-menu-item> -->
    </el-menu>
    <!-- <el-dialog v-model="centerDialog.isShow" :title="centerDialog.title" width="500" align-center>
      <span>{{ centerDialog.content }}</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialog.isShow = false">关闭</el-button>
          <el-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">
            确认
          </el-button>
        </div>
      </template>
    </el-dialog> -->
  </div>
</template>

<style scoped>
.router-link {
  text-decoration: none;
  color: inherit;
}

.head-div {
  width: fit-content;
  margin-top: 5rem;
}

.nav-el-radio {
  position: absolute;
  top: 1rem;
}
</style>
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import {
  Document,
  Menu as IconMenu,
  Location,
} from '@element-plus/icons-vue';
import axios from 'axios';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import { ElMessage, ElNotification } from 'element-plus'
const baseURL = process.env.VUE_APP_API_BASE_URL;
const state = {
  isCollapse: ref(true),
};

const actions = {
  handleOpen: (key: string, keyPath: string[]) => {
    console.log(key, keyPath);
  },
  handleClose: (key: string, keyPath: string[]) => {
    console.log(key, keyPath);
  },
};
// const outLogin = () => {
//   localStorage.removeItem("token");
//   ElMessage.success("退出登录成功")
//   setTimeout(() => {
//     location.reload();
//   }, 1000);
// }
// var centerDialog = ref({
//   isShow: false,
//   title: "info",
//   content: "content",
//   clickBind: ""
// })
// const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
//   if (isShow == false) {
//     centerDialog.value.isShow = false
//   }
//   else {
//     centerDialog.value.title = title
//     centerDialog.value.content = content
//     centerDialog.value.isShow = true
//     centerDialog.value.clickBind = clickBind
//   }
// }
// const centerDialogClick = (act: string) => {
//   switch (act) {
//     case "outLogin":
//       outLogin();
//       break;
//     default:
//       break;
//   }
// }
const isLogin = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/adminApi/isLogin", { timeout: 5000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "https://www.baidu.com"
        }, 1);
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
export default {
  name: 'NavigationBar',
  components: {
    IconMenu,
  },
  setup() {
    onMounted(isLogin)
    return {
      ...state,
      ...actions,
    //   outLogin,
    //   openDialog,
    //   centerDialog,
    //   centerDialogClick,
    //   isLogin
    };
  },
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;

}
.el-menu-vertical-demo {
  margin-right: 0 !important;
  padding-right: 0 !important;
}
</style>
